var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExploreVerified(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_178_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8544 0.814453H10.3378C4.81492 0.814453 0.337769 5.29161 0.337769 10.8145V38.3311C0.337769 43.8539 4.81492 48.3311 10.3378 48.3311H37.8544C43.3772 48.3311 47.8544 43.8539 47.8544 38.3311V10.8145C47.8544 5.29161 43.3772 0.814453 37.8544 0.814453Z",
    fill: "#3ED400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98162 25.9226L8.65747 26.5709L9.09739 27.1498L17.2012 37.569L18.1042 38.7267L19.0304 37.5922L38.7112 13.2575L37.0672 11.6367L18.2895 27.1266L13.2419 21.0603L12.1074 19.6943L11.3202 21.2687L9.00478 25.8995L8.98162 25.9226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0811 40.5795L7.29138 26.7104L11.8527 17.6109L18.4284 25.5064L37.1367 10.0859L40.2624 13.1886L18.0811 40.5795ZM10.0235 26.4325L18.1274 36.8518L37.1598 13.3506L37.0209 13.2117L18.1505 28.7479L12.3621 21.8018L10.0467 26.4325H10.0235Z",
    fill: "#3ED400"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_178_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 49,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreVerified);
export default __webpack_public_path__ + "static/media/ExploreVerified.aac9710c00c2d0108d4b4cc60323b9ff.svg";
export { ForwardRef as ReactComponent };